/**
 * Quick task 260729-cj9 — frontend transport for the company-wide
 * watcher-candidates picker. Endpoint contract:
 *
 *   GET /api/users/watcher-candidates?q={partial}
 *   →   { data: WatcherCandidate[] }   (server caps at 20 rows)
 *
 * Deliberately NOT project-scoped — any active internal user is a valid
 * candidate, mirroring the widened backend addWatcher policy.
 */
import { apiGet } from './client';

export interface WatcherCandidate {
  id: number;
  firstName: string | null;
  lastName: string | null;
  email: string;
}

interface WatcherCandidatesResponse {
  data: WatcherCandidate[];
}

export async function fetchWatcherCandidates(q: string): Promise<WatcherCandidate[]> {
  const trimmed = q.trim();
  const qs = trimmed ? `?q=${encodeURIComponent(trimmed)}` : '';
  const res = await apiGet<WatcherCandidatesResponse>(`/users/watcher-candidates${qs}`);
  return res.data;
}
